import * as ACTION_TYPES from "../../actions/productProfile";

export const INITIAL_STATE = {
    productsProfile: [],
    codigo: 0,
    master: 0,
    status: 0,
    dataCadastro: "00/00/0000",
    descricao: "",
    categoria: 1,
    valor: 0,
};

export const ProductProfileReducer = (state = INITIAL_STATE, action) => {
  if (action.type === 'SESSION_RESET') return { ...INITIAL_STATE };
  switch (action.type) {
    case ACTION_TYPES.GET_ALL_PRODUCTS_PROFILE:
      return {
        ...state,
        productsProfile: action.payload,
      };
    case ACTION_TYPES.GET_PRODUCT_PROFILE:
      return {
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
};
